import { render, staticRenderFns } from "./educationPlanTab.vue?vue&type=template&id=4d555924"
import script from "./educationPlanTab.vue?vue&type=script&lang=js"
export * from "./educationPlanTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d555924')) {
      api.createRecord('4d555924', component.options)
    } else {
      api.reload('4d555924', component.options)
    }
    module.hot.accept("./educationPlanTab.vue?vue&type=template&id=4d555924", function () {
      api.rerender('4d555924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationPlanTab.vue"
export default component.exports